var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sanitas-survey-web',{attrs:{"api-base-url":_vm.baseDomain}})}
var staticRenderFns = []

export { render, staticRenderFns }